// editorblog.js
import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import { BREAKPOINTS } from './breakpoints.js';

export function initEditorblog() {
    const containers = document.querySelectorAll('.tmp-editorblog__mobile.swiper');
    if (!containers.length) return;

    containers.forEach(container => {
        if (container.dataset.swiperInitialized === 'true') {
            return;
        }

        const nextEl = container.querySelector('.swiper-button-next');
        const prevEl = container.querySelector('.swiper-button-prev');
        const paginationEl = container.querySelector('.swiper-pagination');

        const options = {
            slidesPerView: 1,
            spaceBetween: 16,
            loop: false,
            breakpoints: {
                [BREAKPOINTS.MEDIUM]: {
                    enabled: false,
                }
            }
        };

        if (paginationEl) {
            options.pagination = {
                el: paginationEl,
                clickable: true,
            };
        }

        if (nextEl && prevEl) {
            options.navigation = {
                nextEl,
                prevEl,
            };
        }

        new Swiper(container, options);
        container.dataset.swiperInitialized = 'true';
    });
}